import { createContext } from "preact"
import { SearchQuery } from "../../api"
import { AutocompleteOptions } from "./types"

export const Context = createContext<(query: SearchQuery, options?: AutocompleteOptions) => void>(() => {})
